import React from "react";

const Desktop = (props) => {

	const prop = props;

	return (
		<div
			className="button-scroll"
			onClick={() => prop.ScrollToUp()}
			aria-hidden="true"
		>
			<img className="image" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/ic-chevron-top.svg" alt="ic-chevron" />
			<style jsx>
				{`
					.button-scroll {
						position: fixed;
						width: 32px;
						height: 32px;
						padding: 8px;
						bottom: 16px;
						right: 16px;
						background: #DB284E;
						border-radius: 4px;
						cursor: pointer;
						z-index: 3;

						opacity: 1;
    				animation: fade 1s ease-in-out;
					}

					@keyframes fade {
						0% { opacity: 0 }
						50% { opacity: 1 }
					}
				`}
			</style>
		</div>
	);

};

export default Desktop;
